import type { EmotionType, EmotionTrigger, EmotionContext } from '../types/emotion';
import { colors } from './theme';

export interface EmotionOption {
  id: EmotionType;
  label: string;
  emoji: string;
  color: string;
}

export const EMOTION_TYPES: EmotionOption[] = [
  { id: 'fear', label: 'types.fear', emoji: '😰', color: colors.emotion.fear },
  { id: 'greed', label: 'types.greed', emoji: '🤑', color: colors.emotion.greed },
  { id: 'confidence', label: 'types.confidence', emoji: '😎', color: colors.emotion.confidence },
  { id: 'anxiety', label: 'types.anxiety', emoji: '😟', color: colors.emotion.anxiety },
  { id: 'calm', label: 'types.calm', emoji: '😌', color: colors.emotion.calm },
  { id: 'anger', label: 'types.anger', emoji: '😤', color: colors.emotion.anger },
  { id: 'excitement', label: 'types.excitement', emoji: '🤩', color: colors.emotion.excitement },
];

export interface TriggerOption {
  id: EmotionTrigger;
  label: string;
}

export const EMOTION_TRIGGERS: TriggerOption[] = [
  { id: 'consecutive_loss', label: 'triggers.consecutive_loss' },
  { id: 'consecutive_profit', label: 'triggers.consecutive_profit' },
  { id: 'see_opportunity', label: 'triggers.see_opportunity' },
  { id: 'holding_pressure', label: 'triggers.holding_pressure' },
  { id: 'market_volatility', label: 'triggers.market_volatility' },
  { id: 'other', label: 'triggers.other' },
];

export interface ContextOption {
  value: EmotionContext;
  label: string;
}

export const EMOTION_CONTEXTS: ContextOption[] = [
  { value: 'before_trade', label: 'contexts.before_trade' },
  { value: 'during_trade', label: 'contexts.during_trade' },
  { value: 'after_trade', label: 'contexts.after_trade' },
  { value: 'general', label: 'contexts.general' },
];

export const getEmotionById = (id: EmotionType): EmotionOption | undefined => {
  return EMOTION_TYPES.find((e) => e.id === id);
};

export const getEmotionColor = (id: EmotionType): string => {
  return getEmotionById(id)?.color || colors.neutral;
};

export const getEmotionLabel = (id: EmotionType): string => {
  return getEmotionById(id)?.label || id;
};

export const getIntensityColor = (intensity: number): string => {
  if (intensity <= 3) return colors.success;
  if (intensity <= 6) return colors.warning;
  return colors.danger;
};

export const getIntensityLabelKey = (intensity: number): string => {
  if (intensity <= 3) return 'intensity.mild';
  if (intensity <= 6) return 'intensity.moderate';
  return 'intensity.strong';
};

// Deprecated: Use getIntensityLabelKey with t() instead
export const getIntensityLabel = (intensity: number): string => {
  if (intensity <= 3) return '轻微';
  if (intensity <= 6) return '中等';
  return '强烈';
};
